import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import HeroSection from "../components/HeroSection";
import AboutSection from "../components/AboutSection";
import MenuPreview from "../components/MenuPreview";
import EventsPreview from "../components/EventsPreview";
import ContactPreview from "../components/ContactPreview";

const Index: React.FC = () => {
  return (
    <div className="min-h-screen bg-lounge-dark text-lounge-light">
      <Navbar />
      <HeroSection />
      <AboutSection />
      <MenuPreview />
      <EventsPreview />
      <ContactPreview />
      <Footer />
    </div>
  );
};

export default Index;
